import script from "./LocationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationCard.vue?vue&type=script&setup=true&lang=js"

import "./LocationCard.vue?vue&type=style&index=0&id=ef449bb6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef449bb6"]])

export default __exports__